import { fechFromBPartsApi } from '../utils';

export const setCurrentCurrency = ({
  locale,
  currency,
  csrftoken,
}: {
  locale: string;
  currency: string;
  csrftoken: string;
}): Promise<{} | { value: string }> =>
  fechFromBPartsApi(`/${locale}/shop/currencies/change`, {
    method: 'PUT',
    headers: new Headers([
      ['Content-Type', 'application/json'],
      ['X-CSRFToken', csrftoken],
    ]),
    credentials: 'include',
    body: JSON.stringify({ value: currency }),
  }).then(async (value) => {
    if (value.status >= 400 && value.status < 600) {
      const json = await value.json();
      throw json;
    }

    return {};
  });
